module.exports = __webpack_public_path__ + "10ff703778e75974a53028b24e6201ef.png";